import { convertToZonedUTCTime } from "@performyard/utils-isomorphic";

/**
 * Pins an automation end date to 00:30 on the selected day, interpreted in the company timezone,
 * and returns the absolute UTC instant.
 *
 * The automation end date picker is date-only: only the selected calendar day matters, and the
 * time is always normalized to 00:30 company-local. Shared by the create wizard and the edit modal
 * so both store the end date identically.
 */
export const normalizeAutomationEndDate = (pickedDay: Date, companyTimezone: string): Date =>
	convertToZonedUTCTime(
		new Date(pickedDay.getFullYear(), pickedDay.getMonth(), pickedDay.getDate(), 0, 30, 0, 0),
		companyTimezone
	);

/**
 * Calculate the minimum automation end date based on the start date.
 * Which is the following midnight.
 * The end date must be greater than or equal to this date.
 */
export const minimumEndDate = (startDate: Date) => {
	const next = new Date(startDate);
	next.setDate(next.getDate() + 1);
	next.setHours(0, 0, 0, 0);
	return next;
};
